import { I18nProvider } from '@/app/providers/i18n-provider'
import { LandingPage } from '@/features/landing/landing-page'

/**
 * Composition root. The site is a single static page, so there is no router,
 * no data layer, and no auth — just the i18n provider around the page.
 */
export function App() {
  return (
    <I18nProvider>
      <LandingPage />
    </I18nProvider>
  )
}
